<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/flowSourceConfigList' }">流向配置详情</el-breadcrumb-item>
                <el-breadcrumb-item>{{ headerTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="insert">新增</el-button>
                    <el-button size="small" plain @click="copy">复制</el-button>
                    <el-button size="small" plain @click="update">编辑</el-button>
                    <el-button size="small" plain @click="del">删除</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form label-position="right" class="details" label-width="auto">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="账户代码：">
                                    <el-input
                                        v-model="data['account_code']"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="账户：">
                                    <div class="read_only read_only_link">
                                        <span @click="toDetail('account_rid')">{{ data['account_name'] }}</span>
                                    </div>
                                </el-form-item></el-col
                            >
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="RID：">
                                    <el-input
                                        v-model="data['rid']"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input> </el-form-item
                            ></el-col>
                            <el-col :span="12">
                                <el-form-item label="备注：">
                                    <el-input
                                        v-model="data['remark']"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input> </el-form-item
                            ></el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="创建人：">
                                    <el-input
                                        v-model="data['created_by']"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input> </el-form-item
                            ></el-col>
                            <el-col :span="12">
                                <el-form-item label="上次修改人：">
                                    <el-input
                                        v-model="data['updated_by']"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item disabled title="流向" name="2" style="margin-top: -20px">
                    <el-form label-position="right" class="details" label-width="auto">
                        <template>
                            <el-row v-for="(item_out, index_out) in data.F" :key="index_out">
                                <el-col :span="12" v-for="(item, index) in item_out" :key="index">
                                    <el-form-item :key="index" :label="item['label'] + '：'" :prop="item['prop']">
                                        <el-input
                                            v-model="item['source_label']"
                                            size="mini"
                                            class="flex_item_text"
                                            readonly="readonly"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </template>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item disabled title="采购" name="3" style="margin-top: -20px">
                    <el-form label-position="right" class="details" label-width="auto">
                        <template>
                            <el-row v-for="(item_out, index_out) in data.P" :key="index_out">
                                <el-col :span="12" v-for="(item, index) in item_out" :key="index">
                                    <el-form-item :key="index" :label="item['label'] + '：'" :prop="item['prop']">
                                        <el-input
                                            v-model="item['source_label']"
                                            size="mini"
                                            class="flex_item_text"
                                            readonly="readonly"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </template>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item disabled title="库存" name="4" style="margin-top: -20px">
                    <el-form label-position="right" class="details" label-width="auto">
                        <template>
                            <el-row v-for="(item_out, index_out) in data.S" :key="index_out">
                                <el-col :span="12" v-for="(item, index) in item_out" :key="index">
                                    <el-form-item
                                        v-if="!in_array(item['prop'], [''])"
                                        :key="index"
                                        :label="item['label'] + '：'"
                                        :prop="item['prop']"
                                    >
                                        <el-input
                                            v-model="item['source_label']"
                                            size="mini"
                                            class="flex_item_text"
                                            readonly="readonly"
                                        ></el-input>
                                    </el-form-item>
                                    <el-form-item v-else></el-form-item>
                                </el-col>
                            </el-row>
                        </template>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { onDelete, in_array, processColumnDataToRow } from '@/js/common';

export default {
    inject: ['reload'],
    name: 'flowSourceDetail',
    data() {
        return {
            activeNames: ['1', '2', '3', '4'],
            data: {},
            queryParams: {},
            headerTitle: '流向配置详情'
        };
    },
    watch: {
        $route(to, from) {
            this.queryParams.account_rid = to.query.account_rid;
            this.reload();
        }
    },
    beforeMount() {
        this.initQueryParams();
    },
    mounted() {
        this.$nextTick(() => {
            this.getData(); //获取详情
        });
    },
    methods: {
        in_array,
        toDetail(prop) {
            if (prop == 'account_rid') {
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: this.data.account_rid
                    }
                });
            }
        },
        initQueryParams() {
            this.queryParams.account_rid = this.$route.query.account_rid;
        },
        //删除
        del() {
            onDelete(this.data.id, this, 'flowSourceConfigDelete', this.data.account_name, 'flowSourceConfigList');
        },
        //编辑
        update() {
            this.$router.push({
                path: 'flowSourceConfigEdit',
                query: {
                    type: 'update',
                    account_rid: this.data.account_rid
                }
            });
        },
        //新增
        insert() {
            this.$router.push({
                path: 'flowSourceConfigEdit',
                query: {
                    type: 'insert'
                }
            });
        },
        //复制
        copy() {
            this.$router.push({
                path: 'flowSourceConfigEdit',
                query: {
                    type: 'copy',
                    account_rid: this.data.account_rid
                }
            });
        },
        //详情
        getData() {
            this.$api
                .flowSourceConfigDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    let dataF = this.data.F;
                    let dataP = this.data.P;
                    let dataS = this.data.S;
                    this.data.F = [];
                    this.data.P = [];
                    this.data.S = [];
                    processColumnDataToRow(dataF, this, ['data', 'F']);
                    processColumnDataToRow(dataP, this, ['data', 'P']);
                    processColumnDataToRow(dataS, this, ['data', 'S']);
                })
                .catch((error) => {});
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>